import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ContactUs from "./pages/ContactUs";
import GetAQuote from "./pages/GetAQuote";
import ScreenPrinting from "./pages/ScreenPrinting";
import Embroidery from "./pages/Embroidery";
import HeatTransfers from "./pages/HeatTransfers";
import DecalsAndSignage from "./pages/DecalsAndSignage";
import AboutUs from "./pages/AboutUs";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/get-a-quote" element={<GetAQuote />} />
      <Route path="/hybrid-printing" element={<ScreenPrinting />} />
      <Route path="/embroidery" element={<Embroidery />} />
      <Route path="/heat-transfer" element={<HeatTransfers />} />
      <Route path="/decals-and-signage" element={<DecalsAndSignage />} />
      <Route path="/about-us" element={<AboutUs />} />
    </Routes>
  );
}

export default App;
